'use client';

import { Navigate, Outlet } from 'react-router-dom';
import { useAuthData } from '@/hooks/getAuthData';

/** Requires Admin or SystemAdmin (matches server AdminGuard). */
export function RequireAdmin() {
  const { roles } = useAuthData();
  const isAdmin = roles.some(
    (r) => r.name === 'Admin' || r.name === 'SystemAdmin',
  );
  if (!isAdmin) {
    return <Navigate to="/app/dashboard" replace />;
  }
  return <Outlet />;
}
